import { Emoji } from './icons/emoji';
import { Number } from './icons/number';
import { Star } from './icons/star';
import { Score, ScoreIconStyle } from './types';

export interface SingleIconProps {
  score: Score;
  isSelected: boolean;
  size: number;
  scoreIconStyle: ScoreIconStyle;
}

export const SingleIcon = ({
  score,
  scoreIconStyle,
  size,
}: SingleIconProps): JSX.Element | null => {
  if (0 > score || score > 5) {
    return null;
  }

  const props = { score, size, isSelected: true };

  switch (scoreIconStyle) {
    case 'stars':
      return <Star {...props} />;
    case 'numbers':
      return <Number {...props} />;
    case 'emojis':
    default:
      return <Emoji {...props} />;
  }
};
